import { SvgIconModule } from '@core/modules/svgIcons.module';
import { ActionsComponent } from './actions.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CypressDirectiveModule } from '../../../directives/cypress/cypress-directive.module';
import { TooltipDirectiveModule } from '../../../directives/tooltip/tooltip-directive.module';
import { ButtonModule } from '@shared/components/atoms/button/button.module';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
  declarations: [ActionsComponent],
  imports: [
    CommonModule,
    SvgIconModule,
    ButtonModule,
    TranslocoModule,
    CypressDirectiveModule,
    TooltipDirectiveModule,
  ],
  exports: [ActionsComponent],
})
export class ActionsModule {}
